/**
 * Live dictation text from the transcription socket's messages.
 *
 * A partial is a delta (word by word, usually with a leading space). A final is
 * the corrected text of everything since the previous final: models that split
 * speech into segments send one per segment, so a final replaces only the
 * pending words and earlier finals stay.
 */

export interface Transcript {
  /** Finalized segments. */
  committed: string;
  /** Deltas since the last final, as received. */
  pending: string;
}

export const EMPTY_TRANSCRIPT: Transcript = { committed: "", pending: "" };

export function applyTranscriptMessage(
  t: Transcript,
  message: { type: "partial" | "final"; text: string },
): Transcript {
  if (message.type === "partial") return { ...t, pending: t.pending + message.text };
  return { committed: joinDictation(t.committed, message.text.trim() || t.pending), pending: "" };
}

export function transcriptText(t: Transcript): string {
  return joinDictation(t.committed, t.pending);
}

/** Appends words after text: one space between, unless the text is empty or already ends in whitespace. */
export function joinDictation(base: string, text: string): string {
  const words = text.trim();
  if (!words) return base;
  if (!base || /\s$/.test(base)) return base + words;
  return `${base} ${words}`;
}
